import axios from 'axios';
import { ELIXIR_API } from '../constants';

export function headers() {
  const token = JSON.parse(localStorage.getItem('token'));

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer: ${token}`,
  };
}

export function headersNoAuth() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

function parseResponse(response) {
  return response.json().then((json) => {
    if (!response.ok) {
      return Promise.reject(json);
    }
    return json;
  });
}

function queryString(params) {
  const query = Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
  return `${query.length ? '?' : ''}${query}`;
}

export default {
  fetch(url, params = {}) {
    return fetch(`${ELIXIR_API}${url}${queryString(params)}`, {
      method: 'GET',
      headers: headers(),
      withCredentials: true,
    }).then(parseResponse);
  },

  async post(url, data) {
    const API_URL = `${ELIXIR_API}${url}`;
    return axios(API_URL, {
      method: 'POST',
      headers: headers(),
      withCredentials: true,
      data,
    });
  },

  patch(url, data) {
    const body = JSON.stringify(data);

    return fetch(`${ELIXIR_API}${url}`, {
      method: 'PATCH',
      headers: headers(),
      withCredentials: true,
      body,
    }).then(parseResponse);
  },

  delete(url) {
    return fetch(`${ELIXIR_API}${url}`, {
      method: 'DELETE',
      headers: headers(),
      withCredentials: true,
    }).then(parseResponse);
  },
};
